// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"e5875148","224":"e7191a3b","470":"86787718","616":"57307899","767":"8ed2dd08","805":"9c4fc8ec","895":"2062fa43"}[chunkId] + ".css";
};